import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye, Trash2, PenLine, Info, Archive, ArchiveRestore } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";
import {
  DeleteConfirmDialog,
  AddOns,
  AllergenDialog,
  DetailsDialog,
  VariantDialog,
  SaladDialog,
  SauceDialog,
  ArchiveConfirmDialog,
} from "@/components/dialog/common-dialog";
import {
  deleteBurgerById,
  clearBurgerMessages,
  updateExistingBurger,
  fetchAllBurgers,
} from "@/redux/slice/menu-manage-slice/burger-slice";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import hasPermission from "@/hooks/hasPermission";
import { Switch } from "@/components/ui/switch";
import { toggleItemStatus } from "@/api/new-api/staff-management/menu-manage/toggle-status";
import useAuth from "@/hooks/useAuth";

function BurgerListTable({ burgers }) {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { error, requestStatus, deleteLoading, updateLoading } = useSelector(
    (state) => state.menuManage.burger
  );
  const [itemDialog, setItemDialog] = useState(null);
  const [archiveDialog, setArchiveDialog] = useState(false);
  const [archiveActionType, setArchiveActionType] = useState("archive");
  const [variantDetails, setVarianDetails] = useState(false);
  const [saladDialog, setSaladDialog] = useState(false);
  const [sauce, setsauce] = useState(false);
  const [allergenDialog, setAllergenDialog] = useState(false);
  const [vodkaDetailsDialog, setVodkaDetailsDialog] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);

  const closeArchiveDialog = () => {
    setArchiveDialog(false);
    setItemDialog(null);
  };
  const closeVarintDetails = () => {
    setVarianDetails(false);
    setItemDialog(null);
  };
  const colseIngredients = () => {
    setSaladDialog(false);
    setItemDialog(null);
  };
  const colseSauce = () => {
    setsauce(false);
    setItemDialog(null);
  };
  const closeAllergen = () => {
    setAllergenDialog(false);
    setItemDialog(null);
  };
  const closeVodkaDetails = () => {
    setVodkaDetailsDialog(false);
    setItemDialog(null);
  };

  const archiveHandler = async (id, item, type) => {
    try {
      if (!id) {
        toast.error("ID is required.");
        return;
      }
      dispatch(clearBurgerMessages());
      const newStatus = type === "archive" ? "archived" : "active";
      const res = await dispatch(
        updateExistingBurger({
          id,
          data: {
            ...item,
            status: newStatus,
          },
        })
      );
      if (updateExistingBurger.fulfilled.match(res)) {
        toast.success(`Burger archived successfully!`);
      } else if (updateExistingBurger.rejected.match(res)) {
        toast.error(res?.payload || `Failed to archive burger.`);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
    } finally {
      closeArchiveDialog();
    }
  };

  const deleteHandler = async (id) => {
    try {
      if (!id) {
        toast.error("ID is required.");
        return;
      }
      dispatch(clearBurgerMessages());
      const res = await dispatch(deleteBurgerById(id));
      if (deleteBurgerById.fulfilled.match(res)) {
        toast.success(`Burger deleted successfully!`);
      } else if (deleteBurgerById.rejected.match(res)) {
        toast.error(res?.payload || `Failed to delete burger.`);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
    } finally {
      setDeleteDialog(false);
      setItemDialog(null);
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const res = await toggleItemStatus("burgers", id);
      if (res.status === "success") {
        toast.success(res.message || "Burger status updated successfully");
        dispatch(fetchAllBurgers(user?.restaurant_id));
      } else {
        toast.error(res.message || "Failed to toggle status.");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
    }
  };

  return (
    <>
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[100px]">Item No</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Size</TableHead>
            <TableHead>Variant & Price</TableHead>
            <TableHead>Salad</TableHead>
            <TableHead>Sauce</TableHead>
            <TableHead>Calorie Amount</TableHead>
            <TableHead>Allergen</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {burgers && burgers?.length > 0 ? (
            burgers.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">
                  {item?.item_no || "N/A"}
                </TableCell>
                <TableCell>{item?.name}</TableCell>
                <TableCell>{item?.size || "N/A"}</TableCell>
                <TableCell>
                  <span className="flex gap-1 items-center cursor-pointer">
                    {item?.variants_count}
                    <Eye
                      onClick={() => {
                        setVarianDetails(true);
                        setItemDialog(item);
                      }}
                      size={18}
                    />
                  </span>
                </TableCell>
                <TableCell>
                  <span className="flex gap-1 items-center cursor-pointer">
                    {item?.salads_count}
                    <Eye
                      onClick={() => {
                        setSaladDialog(true);
                        setItemDialog(item);
                      }}
                      size={18}
                    />
                  </span>
                </TableCell>
                <TableCell>
                  <span className="flex gap-1 items-center cursor-pointer">
                    {item?.sauces_count}
                    <Eye
                      onClick={() => {
                        setsauce(true);
                        setItemDialog(item);
                      }}
                      size={18}
                    />
                  </span>
                </TableCell>
                <TableCell>{item?.calorie || "00"} Kcal</TableCell>
                <TableCell>
                  <span className="flex gap-1 items-center cursor-pointer">
                    {item?.allergens_count}
                    <Eye
                      size={18}
                      onClick={() => {
                        setAllergenDialog(true);
                        setItemDialog(item);
                      }}
                    />
                  </span>
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    {item?.status === "active" ? (
                      <>
                        <span className="text-cgreen text-base">Active</span>
                        <Switch
                          checked={true}
                          onCheckedChange={() => handleToggleStatus(item.id)}
                        />
                      </>
                    ) : item?.status === "inactive" ? (
                      <>
                        <span className="text-cred text-base">Inactive</span>
                        <Switch
                          checked={false}
                          onCheckedChange={() => handleToggleStatus(item.id)}
                        />
                      </>
                    ) : item?.status === "archived" ? (
                      <span className="text-cred text-base">Archived</span>
                    ) : (
                      <span className="text-cred text-base">Draft</span>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-right justify-end flex gap-2 items-center">
                  <div className="flex items-center gap-2 h-8">
                    <span>
                      <Info
                        onClick={() => {
                          setVodkaDetailsDialog(true);
                          setItemDialog(item);
                        }}
                        className="text-cwhite3 cursor-pointer"
                        size={18}
                      />
                    </span>
                    {hasPermission("back_office.menu_management.update_burger") && item?.status !== "archived" && (
                      <Link
                        to={"/backoffice/menu/burger/update"}
                        state={item}
                        className="cursor-pointer"
                      >
                        <PenLine className="text-cyellow" size={18} />
                      </Link>
                    )}
                      {hasPermission("back_office.menu_management.delete_burger") && item?.status !== "archived" && (
                        <span>
                          {item?.status === "draft" ? (
                            <Trash2
                              onClick={() => {
                                setItemDialog(item);
                                setDeleteDialog(true);
                              }}
                              className="text-cred cursor-pointer"
                              size={18}
                            />
                          ) : (
                            <Archive
                              onClick={() => {
                                setArchiveActionType("archive");
                                setItemDialog(item);
                                setArchiveDialog(true);
                              }}
                              className="text-cred cursor-pointer"
                              size={18}
                            />
                          )}
                        </span>
                      )}
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={10} className="text-center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <AllergenDialog
        items={itemDialog}
        isOpen={allergenDialog}
        onClose={closeAllergen}
      />
      <VariantDialog
        items={itemDialog}
        isOpen={variantDetails}
        onClose={closeVarintDetails}
      />
      <SaladDialog
        items={itemDialog}
        isOpen={saladDialog}
        onClose={colseIngredients}
      />
      <SauceDialog items={itemDialog} isOpen={sauce} onClose={colseSauce} />
      <DetailsDialog
        items={itemDialog}
        isOpen={vodkaDetailsDialog}
        onClose={closeVodkaDetails}
      />
      <ArchiveConfirmDialog
        isLoading={updateLoading}
        isOpen={archiveDialog}
        onClose={closeArchiveDialog}
        onConfirm={() => {
          archiveHandler(itemDialog.id, itemDialog, archiveActionType);
        }}
        title={archiveActionType === "archive" ? "Archive Burger?" : "Restore Burger?"}
        description={
          archiveActionType === "archive"
            ? `Are you sure you want to archive "${itemDialog?.name}"?`
            : `Are you sure you want to restore "${itemDialog?.name}"?`
        }
        isArchive={archiveActionType === "archive"}
      />
      <DeleteConfirmDialog
        isLoading={deleteLoading}
        isOpen={deleteDialog}
        onClose={() => {
          setDeleteDialog(false);
          setItemDialog(null);
        }}
        onConfirm={() => {
          deleteHandler(itemDialog.id);
        }}
        title="Delete Draft Burger?"
        description={`Are you sure you want to delete the draft burger "${itemDialog?.name}"? This action cannot be undone.`}
      />
    </>
  );
}

export default BurgerListTable;
